import './style.scss';
const Footer = () => {
    const logos = [
        {name: 'image1.png', url: 'https://instagram.com/danielnahum___?igshid=MjEwN2IyYWYwYw=='},
        {name: 'image2.png', url: 'https://tportmarket.com/films/prisma/?shareID=2599'},
        {name: 'image3.png', url: 'https://filmfreeway.com/DanielNahum'},
    ]

    return (
        <div className='footer'>
            <div className='logos-links'>
                {logos.map(({id, name, url}, index) => (
                    <a href={url} target='_blank' rel='noreferrer' className='cube' key={index}>
                        <img src={`./images/logos/${name}`} alt='' />
                        {index !== logos.length -1 && <span className='dot'>&#8226;</span>}
                    </a>
                ))}
            </div>
            <p>all rights reserved to &copy; Daniel Nahum</p>
        </div>
    );
}

export default Footer;